import { AjaxHelper } from '@samc/common';

export class ConfigService {
  private readonly _helper: AjaxHelper;

  public constructor(url: string , verificationToken: string | null, client: string | null, jwt: string | null) {
    this._helper = new AjaxHelper(url, verificationToken, client, jwt);
  }

  public async isStandardBankingCalendar(date: string | Date): Promise<boolean> {
    return await this._helper.getData<boolean>('holiday/is/standardbankingcalendar', { date });
  }
}